import { Component, Input } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { LocalizationService } from '../../services/localization.service';

@Component({
    selector: 'apcam-flag',
    templateUrl: './flag.component.html',
    styleUrls: ['./flag.component.scss'],
    imports: [],
})
export class FlagComponent {
    /**
     * Alt attribute of flag image.
     */
    @Input()
    altText: string = this.translateService.instant(
        'shared.selectCountry.flagIcon'
    );

    /**
     * Code for the flag icon.
     *
     * @required
     * @default this.localizationService.defaultLanguage
     */
    @Input({ required: true })
    flagCode: string = this.localizationService.defaultLanguage;

    /**
     * The `width` property specifies the width of the img element containing the flag in pixels.
     *
     * @default 32
     */
    @Input()
    width: number = 32; // [px]

    constructor(
        private readonly localizationService: LocalizationService,
        private readonly translateService: TranslateService
    ) {}
}
